export default __webpack_public_path__ + "static/media/Boardkey.7db9f15a.png";